import React from 'react';
import { Location } from 'history';

import { RCImage } from '@reverbdotcom/cadence/components';

import { CSP, CanonicalProduct } from '@reverbdotcom/commons/src/gql/graphql';
import BLANK_MEDIUM_IMAGE from '../../../../images/products/blank_medium.jpg';
import PriceGuideToolGearCollectionButton from './price_guide_tool_gear_collection_button';

interface IExternalProps {
  csp: CSP;
  canonicalProduct: CanonicalProduct;
  conditionUuid: string;
  showGearCollectionButton?: boolean;
  location?: Location;
}

export function PriceGuideToolFormTitle({
  csp,
  canonicalProduct,
  conditionUuid,
  location,
  showGearCollectionButton,
}: IExternalProps) {

  return (
    <div className="mobile-d-flex bd-1 bd--offwhite bd--darken">
      <div className="mobile-min-width-30">
        <RCImage
          src={csp.image?.source || BLANK_MEDIUM_IMAGE}
          alt={csp.title}
          title={csp.title}
        />
      </div>

      <div className="bdt-1 mobile-bdt-0 mobile-bdl-1 bd--offwhite bd--darken d-flex fx-align-center fx-wrap mobile-fx-align-start padding-2 mobile-padding-4">
        <h1 className="size-80">
          {csp.title}
        </h1>

        {showGearCollectionButton && (
          <PriceGuideToolGearCollectionButton
            csp={csp}
            canonicalProduct={canonicalProduct}
            conditionUuid={conditionUuid}
            location={location}
          />
        )}
      </div>
    </div>
  );
}

export default PriceGuideToolFormTitle;
